import { WidgetDefinition } from "./common";
import WidgetType from "../enum/WidgetType";
import AssetContentMode from "../enum/AssetContentMode";


const Image: WidgetDefinition = {

    type: WidgetType.IMAGE,
    className: "widget-image",
    contentComponent: "dmb-widget-content-image",

    settingsSectionComponents: [
        "dmb-section-widget-settings-image",
        "dmb-section-widget-style",
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        width: 0.2,
        height: 0.2
    },

    defaultStyle: {
        opacity: 100
    },

    defaultSettings: (options) => ({
        assetId: null,
        contentMode: AssetContentMode.COVER,
        repeat: false
    })
};

export default Image;